var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeVector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.984253 8C1.76759 3.73333 5.50675 0.5 10.0001 0.5C14.4934 0.5 18.2318 3.73333 19.0159 8C18.2326 12.2667 14.4934 15.5 10.0001 15.5C5.50675 15.5 1.76842 12.2667 0.984253 8ZM10.0001 12.1667C11.1052 12.1667 12.165 11.7277 12.9464 10.9463C13.7278 10.1649 14.1668 9.10507 14.1668 8C14.1668 6.89493 13.7278 5.83512 12.9464 5.05372C12.165 4.27232 11.1052 3.83333 10.0001 3.83333C8.89502 3.83333 7.83521 4.27232 7.05381 5.05372C6.27241 5.83512 5.83342 6.89493 5.83342 8C5.83342 9.10507 6.27241 10.1649 7.05381 10.9463C7.83521 11.7277 8.89502 12.1667 10.0001 12.1667ZM10.0001 10.5C9.33705 10.5 8.70116 10.2366 8.23232 9.76777C7.76348 9.29893 7.50009 8.66304 7.50009 8C7.50009 7.33696 7.76348 6.70107 8.23232 6.23223C8.70116 5.76339 9.33705 5.5 10.0001 5.5C10.6631 5.5 11.299 5.76339 11.7679 6.23223C12.2367 6.70107 12.5001 7.33696 12.5001 8C12.5001 8.66304 12.2367 9.29893 11.7679 9.76777C11.299 10.2366 10.6631 10.5 10.0001 10.5Z",
    fill: "#1C3B6A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeVector);
export default __webpack_public_path__ + "static/media/eye-vector.3a9dc2816960213175a1f70b324f69a6.svg";
export { ForwardRef as ReactComponent };